import { GOOGLE_CLIENT_ID } from "@wantable/Config";
import { loginToWantableWithSocialmediaToken } from "../helpers/loginWithSocialMedia";
import { gapi } from 'gapi-script';

const useGoogleAuthentication = () => {

  function loginWithGoogle(res: string) {
    loginToWantableWithSocialmediaToken(res, "google");
  };
  return { loginWithGoogle };
};

export default useGoogleAuthentication;
